










































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";

@Component
export default class AppSidebar extends Vue {
  @Prop({ default: true }) isOpen: boolean;
  isOpen$: boolean = false;
  dashboardItems = [
    {
      icon: "mdi-view-dashboard",
      title: "Dashboard",
      link: "/"
    },
    {
      icon: "mdi-message",
      title: "Messages",
      link: "/messages"
    },
    {
      icon: "mdi-arrow-top-right-thick",
      title: "Mixpanel Webhook",
      link: "/webhooks"
    },
    {
      icon: "mdi-arrow-top-right-thick",
      title: "Braze Webhook",
      link: "/braze-webhooks"
    },
    {
      icon: "mdi-cancel",
      title: "BlackLists",
      link: "/blacklists"
    },
    {
      icon: "mdi-account-multiple",
      title: "Users",
      link: "/users"
    }
  ];

  @Emit("onNavigationChanged")
  onUpdated(isOpen: boolean) {
    this.isOpen$ = isOpen;
    return isOpen;
  }

  @Watch("isOpen")
  watchIsOpen(val: boolean, oldVal: boolean) {
    this.isOpen$ = val;
  }
}
